import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import { DialogContent, Grid } from "@material-ui/core";
import accessoriesService from "../../../services/accessories.service";

const initialValues = {
  name: "",
  description: "",
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  description: yupSchema.description,
});
const form = [
  {
    _type: "textField",
    name: "name",
    label: "نام",
    autoFocus: true,
  },

  {
    _type: "textField",
    name: "description",
    label: "توضیحات",
    multiline: true,
    rows: 4,
  },
];

const FormWrapper = ({ children }) => (
  <DialogContent>
    <Grid container spacing={2}>
      {children}
    </Grid>
  </DialogContent>
);

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await accessoriesService.editAccessoryCategory(data.id, model);
    } else {
      op = await accessoriesService.createAccessoryCategory(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "گروه اکسسوری",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
        formWrapper: FormWrapper,
      }}
    />
  );
}
